export default __webpack_public_path__ + "static/media/Q04_渾厚嗓音，大山子民對山林表達的敬畏.fb64cbd9.mp4";